import { dictToURI } from '@/_utilities/generic';
import api from '../_api';

export const sectionService = {
  getItemByURL(url) {
    return api.get(url);
  },
  patchItem(pk, payload) {
    return api.patch(`/sections/${pk}/edit_copy/`, payload);
  },
  patchItemByURL(url, payload) {
    return api.patch(url, payload);
  },
  fetchAsCollaterals(kwargs = {}) {
    return api.get(`/sections/as_collaterals/${dictToURI(kwargs)}`);
  },
  fetchItemAsCollateral(id) {
    return api.get(`/sections/${id}/as_collateral/`);
  },
};
